// @flow

import { useEffect, useMemo } from 'react';
import type { Node } from 'react';
import { bindActionCreators } from 'redux';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from 'shared_services/apollo/useQuery';
import {
  favoritesFetchLoading,
  favoritesFetchDone,
  favoritesFetchError,
} from 'shared_services/redux/actions/favorites/favorites';
import { selectVisitorId } from 'shared_services/redux/selectors/visitor';
import LIST_FAVORITES_QUERY from 'shared_data/queries/favorites/list.graphql';

/**
 * FavoritesListLoader
 *
 * @returns Node
 */
export function FavoritesListLoader(): Node {
  const dispatch: Function = useDispatch();
  const { actionFavoritesFetchLoading, actionFavoritesFetchDone, actionFavoritesFetchError } =
    useMemo(
      () =>
        bindActionCreators(
          {
            actionFavoritesFetchLoading: favoritesFetchLoading,
            actionFavoritesFetchDone: favoritesFetchDone,
            actionFavoritesFetchError: favoritesFetchError,
          },
          dispatch,
        ),
      [dispatch],
    );
  const visitorId = useSelector(selectVisitorId);
  const { loading } = useQuery(LIST_FAVORITES_QUERY, {
    ssr: false,
    skip: !visitorId,
    variables: { visitorId },
    onCompleted: (data) => actionFavoritesFetchDone(data.listFavorites),
    onError: (error) => actionFavoritesFetchError(error),
  });

  useEffect(() => {
    if (loading === true) {
      actionFavoritesFetchLoading();
    }
  }, [loading, actionFavoritesFetchLoading]);

  return null;
}
